import { ChangeEvent } from 'react'

const phoneFormater = (input: HTMLInputElement) => {
  const value = input.value.replace(/\D/g, '').slice(0, 11) // Limita a 11 dígitos
  if (value.length === 11) {
    input.value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`
  } else if (value.length >= 2) {
    if (value.length <= 6) {
      input.value = `(${value.slice(0, 2)}) ${value.slice(2)}`
    } else {
      input.value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`
    }
  } else {
    input.value = value
  }
}

export const phoneMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    phoneFormater(event.target)
  }
}
